

import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Country, State, City } from "country-state-city";
import MultiSelectDropdown from "../../Components/MultiSelectDropdown";
import SelectPage from "./SelectPage";


import { getCurrentUser } from "../../Components/currentUser";


const SchedulingForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [brand, setBrand] = useState([]);
  const [vendor, setVendor] = useState([]);
  const [factory, setFactory] = useState([]);
  const [features, setFeatures] = useState([]);
  const [genres, setGenres] = useState([]);
  // New fields
  const [mboard, setMboard] = useState("");
  const [model, setModel] = useState("");
  const [emac, setEmac] = useState("");
  const [wmac, setWmac] = useState("");
  const [panel, setPanel] = useState("");
  const [lversion, setLversion] = useState("");
  const [ram, setRam] = useState("");
  const [keymd5, setKeymd5] = useState("");
  const [cotaversion, setCotaversion] = useState("");
  const [fotaversion, setFotaversion] = useState("");
  const [lpackage, setLpackage] = useState("");
  const [packageVal, setPackageVal] = useState("");
  const [appversion, setAppversion] = useState("");
  const [apppackage, setApppackage] = useState("");
  const [uid, setUid] = useState("");
  const [oas, setOas] = useState("");
  const [androidversion, setAndroidversion] = useState("");
  const [androidid, setAndroidid] = useState("");
  // End new fields
  const [languages, setLanguages] = useState([]);
  const [contentType, setContentType] = useState([]);
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [pincode, setPincode] = useState("");
  const [loading, setLoading] = useState(false);
  const [brandOptions, setBrandOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [factoryOptions, setFactoryOptions] = useState([]);
  const [featureOptions, setFeatureOptions] = useState([]);
  const [genreOptions, setGenreOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [contentTypeOptions, setContentTypeOptions] = useState([]);
  const [step, setStep] = useState(1);
  const [selectedPages, setSelectedPages] = useState([]);
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [TTLData, setTTLData] = useState([]);
  const [ready, setReady] = useState(false);





  // const DATE_FMT = "MM/dd/yyyy hh:mm aa";
  const DATE_FMT = "MMM dd hh:mm aa";

  const showRequired = (msg) => {
  Swal.fire({
    position: "top-end",
    icon: "warning",
    title: msg,
    showConfirmButton: false,
    timer: 2200,
    toast: true,
    background: "white",
    customClass: {
      popup: "shadow-md rounded-md p-3 text-sm",
    },
  });
};




  useEffect(() => {
  if (!id || !optionsLoaded) return;

  const loadExisting = async () => {
    const { data, error } = await supabase
      .from("scheduling")
      .select("*")
      .eq("id", id)
      .single();

    if (error || !data) return;

    setName(data.name || "");
    setStartTime(data.start_time ? new Date(data.start_time) : null);
    setEndTime(data.end_time ? new Date(data.end_time) : null);

    setBrand(
      (data.brand || [])
        .map((id) => brandOptions.find((x) => x.value === id))
        .filter(Boolean)
    );
    setVendor(
      (data.vendor || [])
        .map((id) => vendorOptions.find((x) => x.value === id))
        .filter(Boolean)
    );
    setFactory(
      (data.factory || [])
        .map((id) => factoryOptions.find((x) => x.value === id))
        .filter(Boolean)
    );

    setFeatures(
      data.features
        ?.map((id) => featureOptions.find((x) => x.value === id))
        .filter(Boolean) || []
    );
    setGenres(
      data.genres
        ?.map((id) => genreOptions.find((x) => x.value === id))
        .filter(Boolean) || []
    );
    setLanguages(
      data.languages
        ?.map((id) => languageOptions.find((x) => x.value === id))
        .filter(Boolean) || []
    );
    setContentType(
      data.content_type
        ?.map((id) => contentTypeOptions.find((x) => x.value === id))
        .filter(Boolean) || []
    );

    // === COUNTRY restore (you already have this) ===
    const countryIso = Country.getAllCountries().find((c) => c.name === data.country)?.isoCode;
    if (data.country && countryIso) {
      setCountry({ label: data.country, value: countryIso });
    } else {
      setCountry(null);
    }

    // === STATE restore (NEW) ===
    // only run if data.state exists and we resolved countryIso
    if (data.state && countryIso) {
      const states = State.getStatesOfCountry(countryIso) || [];
      const matchedState = states.find((s) => s.name === data.state);
      if (matchedState) {
        setState({ label: matchedState.name, value: matchedState.isoCode });
      } else {
        // fallback: try to find by exact isoCode if stored differently
        const matchedByIso = states.find((s) => s.isoCode === data.state);
        if (matchedByIso) {
          setState({ label: matchedByIso.name, value: matchedByIso.isoCode });
        } else {
          setState(null);
        }
      }
    } else {
      setState(null);
    }

    // === CITY restore (NEW) ===
    if (data.city && countryIso) {
      // need a stateIso to list cities — prefer matchedState if available
      const stateIso = (State.getStatesOfCountry(countryIso).find((s) => s.name === data.state) || {}).isoCode
                     || (state && state.value) // fallback to current state value if present
                     || null;
      if (stateIso) {
        const cities = City.getCitiesOfState(countryIso, stateIso) || [];
        const matchedCity = cities.find((c) => c.name === data.city);
        if (matchedCity) {
          setCity({ label: matchedCity.name, value: matchedCity.name });
        } else {
          // fallback to raw string match
          setCity({ label: data.city, value: data.city });
        }
      } else {
        // no state iso available — still set city by label so UI shows something
        setCity({ label: data.city, value: data.city });
      }
    } else {
      setCity(null);
    }

    setPincode(data.pincode || "");
    setSelectedPages(data.pages || []);
    setTTLData(data.TTL || []);
    // Load new fields
    setMboard(data.mboard || "");
    setModel(data.model || "");
    setEmac(data.emac || "");
    setWmac(data.wmac || "");
    setPanel(data.panel || "");
    setLversion(data.lversion || "");
    setRam(data.ram || "");
    setKeymd5(data.keymd5 || "");
    setCotaversion(data.cotaversion || "");
    setFotaversion(data.fotaversion || "");
    setLpackage(data.lpackage || "");
    setPackageVal(data.package || "");
    setAppversion(data.appversion || "");
    setApppackage(data.apppackage || "");
    setUid(data.uid || "");
    setOas(data.oas || "");
    setAndroidversion(data.androidversion || "");
    setAndroidid(data.androidid || "");
  };

  loadExisting();
}, [id, optionsLoaded,
    // include brandOptions/vendorOptions etc. only if mapping uses them — otherwise not needed
]);


 
  useEffect(() => {
    const loadData = async () => {
      const fetchBasic = async (table) => {
        const { data } = await supabase.from(table).select("id, name");
        return data?.map((i) => ({ value: i.id, label: i.name })) || [];
      };

      setBrandOptions(await fetchBasic("Brand"));
      setVendorOptions(await fetchBasic("Vendor"));
      setFactoryOptions(await fetchBasic("Factory"));
      setFeatureOptions(await fetchBasic("Features"));

      const { data: g } = await supabase.from("genres").select("id, genres");
      setGenreOptions(g?.map((i) => ({ value: i.id, label: i.genres })) || []);

      const { data: l } = await supabase
        .from("languages")
        .select("id, languages");
      setLanguageOptions(
        l?.map((i) => ({ value: i.id, label: i.languages })) || []
      );

      const { data: c } = await supabase
        .from("contentType")
        .select("id, contentType");
      setContentTypeOptions(
        c?.map((i) => ({ value: i.id, label: i.contentType })) || []
      );

      setOptionsLoaded(true);
    };
    loadData();
  }, []);


  const handleSave = async (e, selectedPagesOverride = null, TTL = []) => {
  e.preventDefault();
  setLoading(true);

  const payload = {
    name: name.trim(),
    start_time: startTime,
    end_time: endTime,
    brand: brand.map((b) => b.value),
    vendor: vendor.map((v) => v.value),
    factory: factory.map((f) => f.value),
    features: features.map((f) => f.value),
    genres: genres.map((g) => g.value),
    languages: languages.map((l) => l.value),
    content_type: contentType.map((c) => c.value),
    country: country?.label || null,
    state: state?.label || null,
    city: city?.label || null,
    pincode,
    pages: selectedPagesOverride || selectedPages,
    TTL, // 👈 store nested time structure
    // New fields
    mboard,
    model,
    emac,
    wmac,
    panel,
    lversion,
    ram,
    keymd5,
    cotaversion,
    fotaversion,
    package: packageVal,
    lpackage,
    appversion,
    apppackage,
    uid,
    oas,
    androidversion,
    androidid,
  };

  if (id) {
    // await supabase.from("scheduling").update(payload).eq("id", id);
  //   await supabase
  // .from("scheduling")
  // .update({
  //   ...payload,
  //   updated_by: getCurrentUser(),
  // })
  // .eq("id", id);

  await supabase
  .from("scheduling")
  .update({
    ...payload,
    updated_by: getCurrentUser(),
    updated_at: new Date().toISOString(), // ✅ ADD THIS
  })
  .eq("id", id);


  } else {
    await supabase.from("scheduling").insert([payload]);
  }

  setLoading(false);
  navigate("/scheduling");
};


useEffect(() => {
  // Wait until options are loaded AND existing data is loaded (if editing)
  if (!optionsLoaded) return;

  if (!id) {
    setReady(true); // new entry – nothing to load
    return;
  }

  // Editing mode → wait until TTL + pages loaded
  if (TTLData && startTime && endTime) {
    setReady(true);
  }
}, [id, optionsLoaded, TTLData, startTime, endTime]);


const normalize = (v) =>
  v === undefined || v === "" || v === null
    ? null
    : String(v).trim().toLowerCase();

const findDuplicateSchedulings = async (form) => {
  const { data } = await supabase
    .from("scheduling")
    .select(
      "id, name, start_time, end_time, brand, vendor, factory, features, genres, languages, content_type, country, state, city, pincode"
    );

  if (!data) return [];

  const arraysMatch = (a = [], b = []) =>
    JSON.stringify([...a].sort()) === JSON.stringify([...b].sort());

  return data.filter((s) => {
    if (id && s.id === id) return false;

    const sStart = Math.floor(new Date(s.start_time).getTime() / 1000);
    const sEnd = Math.floor(new Date(s.end_time).getTime() / 1000);

    if (sStart !== Math.floor(form.start / 1000)) return false;
    if (sEnd !== Math.floor(form.end / 1000)) return false;

    return (
      arraysMatch(s.brand, form.brand) &&
      arraysMatch(s.vendor, form.vendor) &&
      arraysMatch(s.factory, form.factory) &&
      arraysMatch(s.features, form.features) &&
      arraysMatch(s.genres, form.genres) &&
      arraysMatch(s.languages, form.languages) &&
      arraysMatch(s.content_type, form.content_type) &&
      normalize(s.country) === normalize(form.country) &&
      normalize(s.state) === normalize(form.state) &&
      normalize(s.city) === normalize(form.city) &&
      normalize(s.pincode) === normalize(form.pincode)
    );
  });
};






  return (
    <div className="w-full mx-auto p-6 h-[calc(100vh-1rem)] overflow-auto bg-gray-50 rounded-xl space-y-6">
      <Button
        variant="secondary"
        onClick={() => {
          if (step === 2) {
            setStep(1); // go to step 1
          } else {
            navigate(-1); // leave page
          }
        }}
      >
        ← Back
      </Button>
      <h1 className="text-2xl font-semibold">
        {step === 1
          ? id
            ? "Step 1 : Edit Scheduling"
            : "Step 1 : Add Scheduling"
          : "Step 2 : Select Page"}
      </h1>
      {/* ---------------- STEP 1 ---------------- */}
      {/* {step === 1 && (
        <form onSubmit={handleSave} className="space-y-6"> */}
        {step === 1 && (
  <form onSubmit={handleSave} className="relative h-full">
    <div className="space-y-6 pb-20">

          <div className="bg-white p-5 flex flex-col rounded-xl shadow space-y-3">
            <label className="font-medium text-sm">Name</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            {/* <label className="font-medium text-sm">Start Time</label>
            <DatePicker
              selected={startTime}
              onChange={setStartTime}
              showTimeSelect
              className="mt-1 border border-gray-300 rounded-md py-[6px] px-4 w-full"
            />
            <label className="font-medium text-sm">End Time</label>
            <DatePicker
              selected={endTime}
              onChange={setEndTime}
              showTimeSelect
              className="mt-1 border border-gray-300 rounded-md py-[6px] px-4 w-full"
            /> */}

            <label className="font-medium text-sm">Start Time</label>
            <DatePicker
              selected={startTime}
              onChange={setStartTime}
              showTimeSelect
              timeFormat="hh:mm aa"
              dateFormat={DATE_FMT}
              timeIntervals={15}
              placeholderText="Select start date & time"
              className="mt-1 border border-gray-300 rounded-md py-[6px] px-4 w-full"
            />

            <label className="font-medium text-sm">End Time</label>
            <DatePicker
              selected={endTime}
              onChange={setEndTime}
              showTimeSelect
              timeFormat="hh:mm aa"
              dateFormat={DATE_FMT}
              timeIntervals={15}
              placeholderText="Select end date & time"
              className="mt-1 border border-gray-300 rounded-md py-[6px] px-4 w-full"
            />
          </div>
          <div className="bg-white p-5 rounded-xl shadow space-y-3">
            <label className="font-medium text-sm">Brand</label>
            {/* <MultiSelectDropdown
              options={brandOptions}
              value={brand ? [brand] : []}
              onChange={(v) => setBrand(v[0] || null)}
            /> */}
            <MultiSelectDropdown
              options={brandOptions}
              value={brand}
              onChange={setBrand}
            />

            <label className="font-medium text-sm">Vendor</label>
            {/* <MultiSelectDropdown
              options={vendorOptions}
              value={vendor ? [vendor] : []}
              onChange={(v) => setVendor(v[0] || null)}
            /> */}
            <MultiSelectDropdown
              options={vendorOptions}
              value={vendor}
              onChange={setVendor}
            />
            <label className="font-medium text-sm">Factory</label>
            {/* <MultiSelectDropdown
              options={factoryOptions}
              value={factory ? [factory] : []}
              onChange={(v) => setFactory(v[0] || null)}
            /> */}
            <MultiSelectDropdown
              options={factoryOptions}
              value={factory}
              onChange={setFactory}
            />
            <label className="font-medium text-sm">Features</label>
            <MultiSelectDropdown
              options={featureOptions}
              value={features}
              onChange={setFeatures}
            />
          </div>
          {/* New Fields Section */}
          <div className="bg-white p-5 rounded-xl shadow space-y-3">
            <label className="font-medium text-sm">Board</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={mboard}
              onChange={(e) => setMboard(e.target.value)}
              placeholder="Board"
            />
            <label className="font-medium text-sm">Model</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={model}
              onChange={(e) => setModel(e.target.value)}
              placeholder="Model"
            />
            <label className="font-medium text-sm">Emac</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={emac}
              onChange={(e) => setEmac(e.target.value)}
              placeholder="Emac"
            />
            <label className="font-medium text-sm">Wmac</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={wmac}
              onChange={(e) => setWmac(e.target.value)}
              placeholder="Wmac"
            />
            <label className="font-medium text-sm">Panel</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={panel}
              onChange={(e) => setPanel(e.target.value)}
              placeholder="Panel"
            />
            <label className="font-medium text-sm">Lversion</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={lversion}
              onChange={(e) => setLversion(e.target.value)}
              placeholder="Lversion"
            />
            <label className="font-medium text-sm">Ram</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={ram}
              onChange={(e) => setRam(e.target.value)}
              placeholder="Ram"
            />
            <label className="font-medium text-sm">KeyMd5</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={keymd5}
              onChange={(e) => setKeymd5(e.target.value)}
              placeholder="KeyMd5"
            />
            <label className="font-medium text-sm">Cota Version</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={cotaversion}
              onChange={(e) => setCotaversion(e.target.value)}
              placeholder="Cota Version"
            />
            <label className="font-medium text-sm">Fota Version</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={fotaversion}
              onChange={(e) => setFotaversion(e.target.value)}
              placeholder="Fota Version"
            />
            <label className="font-medium text-sm">Package</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={packageVal}
              onChange={(e) => setPackageVal(e.target.value)}
              placeholder="Package"
            />
            <label className="font-medium text-sm">LPackage</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={lpackage}
              onChange={(e) => setLpackage(e.target.value)}
              placeholder="LPackage"
            />
            <label className="font-medium text-sm">AppVersion</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={appversion}
              onChange={(e) => setAppversion(e.target.value)}
              placeholder="AppVersion"
            />
            <label className="font-medium text-sm">AppPackage</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={apppackage}
              onChange={(e) => setApppackage(e.target.value)}
              placeholder="AppPackage"
            />
            <label className="font-medium text-sm">UID</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={uid}
              onChange={(e) => setUid(e.target.value)}
              placeholder="UID"
            />
            <label className="font-medium text-sm">OAS</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={oas}
              onChange={(e) => setOas(e.target.value)}
              placeholder="OAS"
            />
            <label className="font-medium text-sm">Android Version</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={androidversion}
              onChange={(e) => setAndroidversion(e.target.value)}
              placeholder="Android Version"
            />
            <label className="font-medium text-sm">Android ID</label>
            <input
              className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4 w-full"
              value={androidid}
              onChange={(e) => setAndroidid(e.target.value)}
              placeholder="Android ID"
            />
          </div>
          <div className="bg-white p-5 rounded-xl shadow space-y-3">
            

            <label className="font-medium text-sm">Genres</label>
            <MultiSelectDropdown
              options={genreOptions}
              value={genres}
              onChange={setGenres}
            />
            <label className="font-medium text-sm">Languages</label>
            <MultiSelectDropdown
              options={languageOptions}
              value={languages}
              onChange={setLanguages}
            />
            <label className="font-medium text-sm">Content Type</label>
            <MultiSelectDropdown
              options={contentTypeOptions}
              value={contentType}
              onChange={setContentType}
            />
          </div>
          <div className="bg-white p-5 rounded-xl shadow space-y-3">
            <label className="font-medium text-sm">Country</label>
            <MultiSelectDropdown
              options={Country.getAllCountries().map((c) => ({
                label: c.name,
                value: c.isoCode,
              }))}
              value={country ? [country] : []}
              onChange={(v) => setCountry(v[0] || null)}
            />
            <label className="font-medium text-sm">State</label>
            <MultiSelectDropdown
              options={
                country
                  ? State.getStatesOfCountry(country.value).map((s) => ({
                      label: s.name,
                      value: s.isoCode,
                    }))
                  : []
              }
              value={state ? [state] : []}
              onChange={(v) => setState(v[0] || null)}
            />
            <label className="font-medium text-sm">City</label>
            <MultiSelectDropdown
              options={
                state
                  ? City.getCitiesOfState(country.value, state.value).map(
                      (c) => ({ label: c.name, value: c.name })
                    )
                  : []
              }
              value={city ? [city] : []}
              onChange={(v) => setCity(v[0] || null)}
            />
            <div className="flex flex-col">
              <label className="font-medium text-sm">Pincode</label>
              <input
                className="input mt-1 border border-1 border-gray-300 rounded-md py-[6px] px-4"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
              />
            </div>
          </div>
              </div>

          {/* <div className="flex justify-end"> */}
          <div className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 flex justify-end z-20">

           


<button
  type="button"
  className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-4 py-[6px] rounded-md"
  onClick={async () => {

    if (!name.trim()) return showRequired("Name is required");
    if (!startTime) return showRequired("Start time is required");
    if (!endTime) return showRequired("End time is required");

    // Duplicate check BEFORE Step 2
    // const duplicates = await findDuplicateSchedulings();
    const snapshot = {
  start: new Date(startTime).getTime(),
  end: new Date(endTime).getTime(),
  brand: brand.map(b => b.value),
  vendor: vendor.map(v => v.value),
  factory: factory.map(f => f.value),
  features: features.map(f => f.value),
  genres: genres.map(g => g.value),
  languages: languages.map(l => l.value),
  content_type: contentType.map(c => c.value),
  country: country?.label || null,
  state: state?.label || null,
  city: city?.label || null,
  pincode: pincode || null,
};
const duplicates = await findDuplicateSchedulings(snapshot);

    if (duplicates.length > 0) {
      const names = duplicates.map(d => `• ${d.name}`).join("\n");
      const result = await Swal.fire({
        title: `${duplicates.length} similar scheduling(s) found`,
        text: `The following scheduling(s) match the same timings:\n\n${names}\n\nProceed anyway?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        width: 600,
      });

      if (!result.isConfirmed) return;
    }

    // JUST move to step 2 — DO NOT SAVE ANYTHING
    setStep(2);
  }}
>
  Next
</button>



          </div>
        </form>
      )}
      {/* ---------------- STEP 2 ---------------- */}
      {step === 2 && (
        <SelectPage
          onBack={() => setStep(1)}
          selectedPages={selectedPages}
          startTime={startTime}
          endTime={endTime}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
            initialTTL={TTLData} // 👈 new prop
          // onSave={(selectedItems) => {
          //   const pageIds = selectedItems.map((i) => i.id);
          //   setSelectedPages(pageIds);
          //   handleSave(
          //     { preventDefault: () => {} },
          //     pageIds // Pass pageIds as selectedPagesOverride
          //   );
          // }}
//           onSave={(selectedItems, TTL) => {
//   const pageIds = selectedItems.map((i) => i.id);
//   setSelectedPages(pageIds);
//   handleSave({ preventDefault: () => {} }, pageIds, TTL);
// }}



onSave={async (selectedItems, TTL) => {
  if (!name.trim()) return showRequired("Name is required");
  if (!startTime) return showRequired("Start time is required");
  if (!endTime) return showRequired("End time is required");

  const pageIds = selectedItems.map(i => i.id);

  const payload = {
    name: name.trim(),
    start_time: startTime,
    end_time: endTime,
    brand: brand.map(b => b.value),
    vendor: vendor.map(v => v.value),
    factory: factory.map(f => f.value),
    features: features.map(f => f.value),
    genres: genres.map(g => g.value),
    languages: languages.map(l => l.value),
    content_type: contentType.map(c => c.value),
    country: country?.label || null,
    state: state?.label || null,
    city: city?.label || null,
    pincode,
    pages: pageIds,
    TTL,
    // New fields
    mboard,
    model,
    emac,
    wmac,
    panel,
    lversion,
    ram,
    keymd5,
    cotaversion,
    fotaversion,
    package: packageVal,
    lpackage,
    appversion,
    apppackage,
    uid,
    oas,
    androidversion,
    androidid,
  };

  let error;
  if (id) {
    // update mode
    // ({ error } = await supabase.from("scheduling").update(payload).eq("id", id));
  //   ({ error } = await supabase
  // .from("scheduling")
  // .update({
  //   ...payload,
  //   updated_by: getCurrentUser(),
  // })
  // .eq("id", id));

  ({ error } = await supabase
  .from("scheduling")
  .update({
    ...payload,
    updated_by: getCurrentUser(),
    updated_at: new Date().toISOString(), // ✅ ADD THIS
  })
  .eq("id", id));


  } else {
    // create mode
    const { error: insertErr } = await supabase.from("scheduling").insert([payload]);
    error = insertErr;
  }

  if (error) {
    console.error(error);
    alert("Error saving scheduling");
    return;
  }

  navigate("/scheduling");
}}



          fetchItems={async (page, limit, search) => {
            const query = supabase
              .from("pages")
              .select("id, page_name", { count: "exact" })
              .order("page_name", { ascending: true })
              .range((page - 1) * limit, page * limit - 1);
            if (search) query.ilike("page_name", `%${search}%`);
            const { data, count } = await query;
            return {
              data: data || [],
              total: Math.ceil((count || 0) / limit),
            };
          }}
        />
      )}
    </div>
  );
};

export default SchedulingForm;
